import * as React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import classNames from "classnames";

type HeadingType = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "div";

interface IProps {
    children?: React.ReactNode;
    className?: string;
    type: HeadingType;
    padding?: string;
}

export const Heading = (props: IProps) => {
    const className = classNames(props.className);
    switch (props.type) {
        case "h1":
            return (
                <HeadingBaseH1 className={className} padding={props.padding}>
                    {props.children}
                </HeadingBaseH1>
            );
        case "h2":
            return (
                <HeadingBaseH2 className={className} padding={props.padding}>
                    {props.children}
                </HeadingBaseH2>
            );
        case "h3":
            return (
                <HeadingBaseH3 className={className} padding={props.padding}>
                    {props.children}
                </HeadingBaseH3>
            );
        case "h4":
            return (
                <HeadingBaseH4 className={className} padding={props.padding}>
                    {props.children}
                </HeadingBaseH4>
            );
        case "h5":
            return (
                <HeadingBaseH5 className={className} padding={props.padding}>
                    {props.children}
                </HeadingBaseH5>
            );
        case "h6":
            return (
                <HeadingBaseH6 className={className} padding={props.padding}>
                    {props.children}
                </HeadingBaseH6>
            );
        case "div":
            return (
                <HeadingBaseDiv className={className} padding={props.padding}>
                    {props.children}
                </HeadingBaseDiv>
            );
    }
};

interface IThemeProps {
    padding?: string;
}

const headingBase = css`
    margin: 0;
`;

const HeadingBaseH1 = styled.h1<IThemeProps>`
    ${headingBase};
    padding: ${(props) => (props.padding ? props.padding : "3rem 0 3rem 0")};
`;

const HeadingBaseH2 = styled.h2<IThemeProps>`
    ${headingBase};
    padding: ${(props) => (props.padding ? props.padding : "3rem 0 3rem 0")};
`;

const HeadingBaseH3 = styled.h3<IThemeProps>`
    ${headingBase};
    padding: ${(props) => (props.padding ? props.padding : "3rem 0 3rem 0")};
`;

const HeadingBaseH4 = styled.h4<IThemeProps>`
    ${headingBase};
    padding: ${(props) => (props.padding ? props.padding : "3rem 0 3rem 0")};
`;

const HeadingBaseH5 = styled.h5<IThemeProps>`
    ${headingBase};
    padding: ${(props) => (props.padding ? props.padding : "3rem 0 3rem 0")};
`;

const HeadingBaseH6 = styled.h6<IThemeProps>`
    ${headingBase};
    padding: ${(props) => (props.padding ? props.padding : "3rem 0 3rem 0")};
`;

const HeadingBaseDiv = styled.div<IThemeProps>`
    ${headingBase};
    padding: ${(props) => (props.padding ? props.padding : "3rem 0 3rem 0")};
`;
import * as React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import classNames from "classnames";

type HeadingType = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "div";

interface IProps {
    children?: React.ReactNode;
    className?: string;
    type: HeadingType;
    padding?: string;
}

export const Heading = (props: IProps) => {
    const className = classNames(props.className);
    switch (props.type) {
        case "h1":
            return (
                <HeadingBaseH1 className={className} padding={props.padding}>
                    {props.children}
                </HeadingBaseH1>
            );
        case "h2":
            return (
                <HeadingBaseH2 className={className} padding={props.padding}>
                    {props.children}
                </HeadingBaseH2>
            );
        case "h3":
            return (
                <HeadingBaseH3 className={className} padding={props.padding}>
                    {props.children}
                </HeadingBaseH3>
            );
        case "h4":
            return (
                <HeadingBaseH4 className={className} padding={props.padding}>
                    {props.children}
                </HeadingBaseH4>
            );
        case "h5":
            return (
                <HeadingBaseH5 className={className} padding={props.padding}>
                    {props.children}
                </HeadingBaseH5>
            );
        case "h6":
            return (
                <HeadingBaseH6 className={className} padding={props.padding}>
                    {props.children}
                </HeadingBaseH6>
            );
        case "div":
            return (
                <HeadingBaseDiv className={className} padding={props.padding}>
                    {props.children}
                </HeadingBaseDiv>
            );
    }
};

interface IThemeProps {
    padding?: string;
}

const headingBase = css`
    margin: 0;
`;

const HeadingBaseH1 = styled.h1<IThemeProps>`
    ${headingBase};
    padding: ${(props) => (props.padding ? props.padding : "3rem 0 3rem 0")};
`;

const HeadingBaseH2 = styled.h2<IThemeProps>`
    ${headingBase};
    padding: ${(props) => (props.padding ? props.padding : "3rem 0 3rem 0")};
`;

const HeadingBaseH3 = styled.h3<IThemeProps>`
    ${headingBase};
    padding: ${(props) => (props.padding ? props.padding : "3rem 0 3rem 0")};
`;

const HeadingBaseH4 = styled.h4<IThemeProps>`
    ${headingBase};
    padding: ${(props) => (props.padding ? props.padding : "3rem 0 3rem 0")};
`;

const HeadingBaseH5 = styled.h5<IThemeProps>`
    ${headingBase};
    padding: ${(props) => (props.padding ? props.padding : "3rem 0 3rem 0")};
`;

const HeadingBaseH6 = styled.h6<IThemeProps>`
    ${headingBase};
    padding: ${(props) => (props.padding ? props.padding : "3rem 0 3rem 0")};
`;

const HeadingBaseDiv = styled.div<IThemeProps>`
    ${headingBase};
    padding: ${(props) => (props.padding ? props.padding : "3rem 0 3rem 0")};
`;
